export default "__VITE_ASSET__DEwnHL5f__"